<template>
  <b-container class="mb-4" v-if="item">
    <b-card header="Domain">
      <b-form-group label="Domain:" invalid-feedback="Must be a valid apex domain e.g. 'example.com'" description="Create an A record pointing at 104.198.14.52">
        <b-form-input v-model="item.domain" required placeholder="example.com" :state="validate_state('domain')" @change="edit_item"></b-form-input>
      </b-form-group>

      <b-link v-if="site.host_id" :href="`https://${site.id}.netlify.app`" target="_blank">https://{{site.id}}.netlify.app</b-link>
    </b-card>

    <b-card class="mt-4" header="Page">
      <b-form-group label="Custom head:" description="Added at the bottom of the head tag">
        <b-form-textarea v-model="item.custom_head" @change="edit_item"></b-form-textarea>
      </b-form-group>

      <b-form-group label="Custom body:" description="Added at the bottom of the body tag">
        <b-form-textarea v-model="item.custom_body" @change="edit_item"></b-form-textarea>
      </b-form-group>
    </b-card>

    <b-card class="mt-4" header="Footer">
      <b-form-group label="Footer HTML:">
        <b-form-textarea v-model="item.footer" @change="edit_item"></b-form-textarea>
      </b-form-group>
    </b-card>

  </b-container>
</template>

<script>
import { db, serverTimestamp, FieldValue } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"

function valid_domain(val) {
  if (!val) {
    return true
  }
  return /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/.test(val)
}

export default {
  name: 'site_edit',
  mixins: [ItemMixin],
  props: ['profile', 'site'],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.site_id)
    }
  },
  validations: {
    item: {
      domain: {valid_domain},
    }
  },
  data() {
    return {
      item: undefined,
      is_saving: false,
      collection: 'site'
    }
  },
  methods: {
    async after_write() {
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    }
  },
  metaInfo() {
    return {
      title: `${this.collection} edit`
    };
  },
}
</script>

<style scoped>

</style>
